export default "__VITE_ASSET__C0djn$6G__"